var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{class:_vm.className},[_c('div',{staticClass:"loader"},[_c('Icon',{attrs:{"colorValue":_vm.colorValue,"isEmbed":_vm.isEmbed}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }